export default "__VITE_ASSET__BsA_YZrT__"